import axios from "axios";

// Resolve the backend URL at runtime so the app always calls the same origin
// it's served from. This avoids cross-origin CORS issues when the app is
// accessed via a custom domain (sakuratreats.com) vs the build-time URL.
const BUILD_BACKEND = process.env.REACT_APP_BACKEND_URL;

function resolveBackend() {
  if (typeof window === "undefined") return BUILD_BACKEND || "";
  const here = window.location.origin;
  // If we're served from a real production-looking origin, prefer it.
  // This makes the app work on any custom domain without rebuilding.
  if (here && /^https?:\/\//.test(here) && !here.includes("localhost")) {
    return here;
  }
  return BUILD_BACKEND || here;
}

const BACKEND_URL = resolveBackend();
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach token from localStorage if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sakura_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
